var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 50,
    height: 33,
    rx: 4,
    transform: "translate(0 0.111)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6407",
    "data-name": "Mask Group 6407",
    transform: "translate(0 -0.111)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32157",
    "data-name": "Path 32157",
    d: "M0,0H50.133V32.726H0Z",
    transform: "translate(0 -0.028)",
    fill: "#6c8bf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_51",
    "data-name": "Intersection 51",
    transform: "translate(22.746 -0.026)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.03,32.725,0,13.171,7.431,0H27.387V32.725Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.38700294494629 32.72463989257812 L 27.38700294494629 -1.961059524546727e-06 L 7.430573463439941 -1.961059524546727e-06 L 3.379821691851248e-06 13.17087841033936 L 11.03019332885742 32.72463989257812 L 27.38700294494629 32.72463989257812 M 28.38700294494629 33.72463989257812 L 10.44616317749023 33.72463989257812 L -1.148146629333496 13.17084789276123 L 6.846573352813721 -1.000001907348633 L 28.38700294494629 -1.000001907348633 L 28.38700294494629 33.72463989257812 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_52",
    "data-name": "Intersection 52",
    transform: "translate(-0.001 9.128)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.57V9.217A20.134,20.134,0,0,1,16.816,0C28.05,0,37.159,9.446,37.159,21.094a22.029,22.029,0,0,1-.14,2.476Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.01945495605469 23.57013702392578 C 37.11125564575195 22.75865745544434 37.15899276733398 21.93187713623047 37.15899276733398 21.09409713745117 C 37.15899276733398 9.445796966552734 28.05038452148438 -3.395385647309013e-06 16.8157844543457 -3.395385647309013e-06 C 9.827064514160156 -3.395385647309013e-06 3.662044525146484 3.65286660194397 4.476318281376734e-06 9.216926574707031 L 4.476318281376734e-06 23.57013702392578 L 37.01945495605469 23.57013702392578 M 37.91270446777344 24.57013702392578 L -0.9999955296516418 24.57013702392578 L -0.9999955296516418 8.917376518249512 L -0.8353155255317688 8.667156219482422 C 3.148704528808594 2.613886594772339 9.747244834899902 -1.000003337860107 16.8157844543457 -1.000003337860107 C 19.70103454589844 -1.000003337860107 22.50025367736816 -0.4138633906841278 25.13569450378418 0.7421365976333618 C 27.67817497253418 1.857346653938293 29.9608039855957 3.453006505966187 31.92017364501953 5.484766483306885 C 33.8770751953125 7.513956546783447 35.41328430175781 9.876337051391602 36.48615264892578 12.50629615783691 C 37.59616470336914 15.22731685638428 38.15899276733398 18.11667633056641 38.15899276733398 21.09409713745117 C 38.15899276733398 21.95600700378418 38.10991287231445 22.8268871307373 38.01311492919922 23.68254661560059 L 37.91270446777344 24.57013702392578 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M2.785,0H47.348a2.785,2.785,0,0,1,2.785,2.785V29.94a2.785,2.785,0,0,1-2.785,2.785H2.785A2.785,2.785,0,0,1,0,29.94V2.785A2.785,2.785,0,0,1,2.785,0Z",
    transform: "translate(0 -0.028)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_53",
    "data-name": "Intersection 53",
    transform: "translate(22.748 10.562)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.028,22.135,0,2.584,1.454,0A21.1,21.1,0,0,1,14.413,19.66a21.725,21.725,0,0,1-.141,2.475Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.27243232727051 22.13505935668945 C 14.36545181274414 21.32357788085938 14.41318225860596 20.49802780151367 14.41318225860596 19.65962791442871 C 14.41318225860596 10.7131986618042 9.037611961364746 3.066598653793335 1.454052090644836 -1.275329623240395e-06 L 2.082977289319388e-06 2.583748817443848 L 11.02775192260742 22.13505935668945 L 14.27243232727051 22.13505935668945 M 15.16435241699219 23.13505935668945 L 10.44369220733643 23.13505935668945 L -1.147787928581238 2.584308624267578 L 1.013802051544189 -1.256691217422485 L 1.828932046890259 -0.9270712733268738 C 5.790031909942627 0.6746987104415894 9.171462059020996 3.439148664474487 11.60766220092773 7.067428588867188 C 14.09725189208984 10.77522850036621 15.41318225860596 15.12953853607178 15.41318225860596 19.65962791442871 C 15.41318225860596 20.52535820007324 15.3636417388916 21.39652824401855 15.26592254638672 22.24893951416016 L 15.16435241699219 23.13505935668945 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtual);
export default __webpack_public_path__ + "static/media/virtual.1aeaa1dd50d6086595d2accd1d3e949f.svg";
export { ForwardRef as ReactComponent };